import { HeaderTemplate } from 'packages/ui/src/templates';
import { useLocation } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import '../styles/css/style.scss';
import { useRecoilState, useRecoilValue } from 'recoil';
import globalState from '../state/globalState';
import env from 'config/env';
import AdminApi from 'api/AdminApi';
import UserApi from 'api/UserApi';
import ApiMapper from 'constant/ApiMapper';

const API_URL = `${env().MAIN_PATH}`;

interface HeaderWrapProps {
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function HeaderWrap({ setModalOpen }: HeaderWrapProps) {
  const location = useLocation();

  const { isAdmin, UserInformation } = useRecoilValue(globalState);
  const [userState, setUserState] = useRecoilState(globalState);

  const mapper = ApiMapper.AUTH;

  const isLinkActive = useCallback(
    (href) => {
      return location.pathname.startsWith(href);
    },
    [location],
  );

  const logoutApi = async () => {
    if (userState.UserInformation.token) {
      try {
        const result = await UserApi.Logout({ url: mapper.LOGOUT, token: userState.UserInformation.token });
      } catch (e) {
        // alert('올바른 로그인 정보가 아닙니다. 아이디 및 비밀번호를 다시 한번 확인해주세요.');
        return false;
      }
    }
  };

  const logoutFunc = () => {
    //  로그인 정보 제거
    setUserState((prevState) => ({
      ...prevState,
      UserInformation: {
        regUserId: '',
        regUserName: '',
        userId: '',
        user_nm: '',
        ofcNm: '',
        CompanyID: '',
        CompanyName: '',
        ServiceID: '',
        token: '',
        ctpvNm: '',
        deptNm: '',
      },
      userService: {
        CROPS: '',
        FORST: '',
        OCEAN: '',
      },
      stae: {
      CROPS: '',
      FORST: '',
      OCEAN: '',
    },
      isLogin: false,
      isAdmin: false,
      currentPage: {
        title: '',
        url: '/',
      },
    }));

    //로그아웃 세션 삭제
    logoutApi();

    alert('정상적으로 로그아웃 되었습니다.');
    window.location.href = '/main/logout';
  };

  return (
    <HeaderTemplate
      title="임업직불제 영상처리 시스템"
      rootPath="/"
      isAdmin={isAdmin}
      userName={UserInformation.user_nm}
      mainUrl={API_URL}
      logoutFunc={logoutFunc}
      setModalOpen={setModalOpen}
      category={
        <>        </>
      }
    />
  );
}

export default HeaderWrap;
